module.exports = __webpack_public_path__ + "img/gb9123_17_b.prt.1cc1082b.jpg";